export default "__VITE_ASSET__RCAgWysm__"